export class UpdateTransacitonStatus{
    id:number;
    kindId:number;
    status:number;
}